
export interface WebContact
{
    Seq?: number;
    Key?: string;
    FirstName: string;
    LastName?: string;
    PhoneDesc?: string;
    PhoneCountryCode?: number;
    PhoneNumber?: string;
    PhoneExt?: string;
    Type: string;
    Email?: string;
    ApplCode: string;
    AllowEmailMsg: boolean;
    AllowPhoneTextMsg: boolean;
    NotificationOptions: string;
    DefaultInvoice: boolean;
    DefaultStatements: boolean;
    DefaultLetters: boolean;
}

export const webContactDefault = { FirstName: "", Type: "1", ApplCode: "C" };
